// extracted by mini-css-extract-plugin
export default {"input":"E8-z","button":"F8-z","selected":"G8-z","unavailable":"H8-z","oos":"I8-z","image":"J8-z","paperCutDisabledOverlay":"K8-z"};